module.exports = __webpack_public_path__ + "img/serveItem4.b96723c4.png";